exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".welcome-card-component{color:#fff;position:relative;margin:0 8px;height:420px;border-radius:8px;background-repeat:no-repeat;background-position:50%;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}.welcome-card-component__header{padding:16px}.welcome-card-component__content{position:absolute;right:16px;left:16px;bottom:16px}@media (max-width:768px){.welcome-card-component__title{font-size:26px!important}}.welcome-card-component__link{color:#fff!important;text-decoration:none!important;border:3px solid #fff!important;border-radius:10px!important;font-weight:800!important}.welcome-card-component__overlay{border-radius:8px;position:absolute;top:0;bottom:0;right:0;left:0;background:rgba(0,0,0,.55)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/welcome/card.scss
// module id = 1037
// module chunks = 0